export default __webpack_public_path__ + "static/media/04-WorkoutTracker-Main.34455002.PNG";